import { ElementNumbers, ElementRoutes } from '../../models/element';
import { Menu } from '../../models/menu';

export class MenuUtils {
  static convertMenuItems(menu: Menu[], elementId: ElementNumbers, siteType: string): Menu[] {
    return menu
      .filter(item => item.currentUserCanAccess)
      .map(s => ({
        ...s,
        childMenus: s.childMenus.length
          ? s.childMenus.map(c => ({
              ...c,
              id: c.menuId,
              navigateUrls: c.navigateUrl ? [ElementRoutes.get(elementId), c.navigateUrl] : null,
              description: this.getMenuLabel(c.description, siteType)
            }))
          : [],
        navigateUrls: s.navigateUrl ? [ElementRoutes.get(elementId), s.navigateUrl] : null
      }));
  }

  static getMenuLabel(childMenu: string, siteType: string): string {
    if (childMenu === MenuOption.Transactions) {
      return `${siteType} ${childMenu}`;
    }
    return childMenu;
  }
}

export const MenuOption = {
  Dashboard: 'Dashboard',
  Transactions: 'Transactions'
};

export type MenuOptions = (typeof MenuOption)[keyof typeof MenuOption];
